// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z5-2","question":"styles_question__2GA6V","description":"styles_description__3rHqI"};